const geoData = {
  IT: [
    [
      [
        [15.520376010813834, 38.23115509699147],
        [15.160242954171736, 37.44404551853782],
        [15.309897902089006, 37.1342194687318],
        [15.09998823411945, 36.6199872909954],
        [14.335228712632016, 36.996630967754754],
        [13.82673261887993, 37.1045313583802],
        [12.431003859108813, 37.61294993748382],
        [12.570943637755136, 38.12638113051969],
        [13.741156447004585, 38.03496552179536],
        [14.76124922044616, 38.143873602850505],
        [15.520376010813834, 38.23115509699147],
      ],
    ],
    [
      [
        [9.210011834356266, 41.20999136002422],
        [9.809975213264977, 40.5000088567661],
        [9.669518670295673, 39.177376410471794],
        [9.21481774255949, 39.240473334300134],
        [8.80693566247973, 38.90661774347848],
        [8.428302443077115, 39.17184703221662],
        [8.38825320805094, 40.378310858718805],
        [8.15999840661766, 40.95000722916379],
        [8.709990675500109, 40.89998444270523],
        [9.210011834356266, 41.20999136002422],
      ],
    ],
    [
      [
        [12.376485223040845, 46.76755910906988],
        [13.806475457421556, 46.50930613869119],
        [13.698109978905478, 46.016778062517375],
        [13.937630242578336, 45.591015936864665],
        [13.141606479554298, 45.73669179949542],
        [12.328581170306308, 45.381778062514854],
        [12.383874952858605, 44.88537425391908],
        [12.261453484759159, 44.600482082694015],
        [12.589237094786483, 44.091365871754476],
        [13.526905958722494, 43.58772736263791],
        [14.029820997787027, 42.76100779883248],
        [15.142569614327954, 41.955139675456905],
        [15.926191033601896, 41.96131500911574],
        [16.169897088290412, 41.740294908203424],
        [15.889345737377795, 41.5410822617182],
        [16.785001661860576, 41.179605617836586],
        [17.519168735431208, 40.87714345963224],
        [18.376687452882578, 40.35562490494266],
        [18.480247023195403, 40.168866278639825],
        [18.2933850440281, 39.81077444107325],
        [17.738380161213286, 40.2776710068303],
        [16.869595981522338, 40.44223460546385],
        [16.448743116937322, 39.79540070246648],
        [17.1714896989715, 39.42469981542072],
        [17.052840610429342, 38.902871202137305],
        [16.635088331781844, 38.8435724960824],
        [16.100960727613057, 37.98589874933418],
        [15.684086948314501, 37.90884918878703],
        [15.68796268073632, 38.214592800441864],
        [15.891981235424709, 38.750942491199226],
        [16.109332309644316, 38.96454702407769],
        [15.718813510814641, 39.544072374014945],
        [15.413612501698822, 40.04835683853517],
        [14.998495721098237, 40.17294871679093],
        [14.70326826341477, 40.604550279292624],
        [14.060671827865264, 40.78634796809544],
        [13.627985060285397, 41.188287258461656],
        [12.88808190273042, 41.25308950455562],
        [12.10668257004491, 41.70453481705741],
        [11.191906365614187, 42.35542531998968],
        [10.511947869517797, 42.931462510747224],
        [10.200028924204048, 43.920006822274615],
        [9.702488234097814, 44.03627879493132],
        [8.88894616052687, 44.36633616797954],
        [8.428560825238577, 44.23122813575242],
        [7.850766635783202, 43.76714793555524],
        [7.435184767291844, 43.69384491634918],
        [7.549596388386163, 44.12790110938482],
        [7.007562290076663, 44.25476675066139],
        [6.749955275101712, 45.02851797136759],
        [7.096652459347837, 45.333098863295874],
        [6.802355177445662, 45.70857982032868],
        [6.843592970414562, 45.99114655210067],
        [7.273850945676685, 45.77694774025076],
        [7.755992058959833, 45.82449005795928],
        [8.31662967289438, 46.163642483090854],
        [8.489952426801295, 46.00515086525175],
        [8.966305779667834, 46.036931871111165],
        [9.182881707403112, 46.44021474871698],
        [9.922836541390353, 46.31489940040919],
        [10.363378126678668, 46.483571275409844],
        [10.442701450246602, 46.893546250997446],
        [11.048555942436508, 46.7513585475464],
        [11.164827915093326, 46.94157949481274],
        [12.153088006243081, 47.11539317482644],
        [12.376485223040845, 46.76755910906988],
      ],
    ],
  ],
  RU: [
    [
      [
        [143.64800744036287, 50.74760040954152],
        [144.65414757708564, 48.976390692737596],
        [143.17392785051723, 49.30655141865037],
        [142.5586682476501, 47.861575018904915],
        [143.53349246640406, 46.83672801369249],
        [143.50527713437262, 46.13790761980948],
        [142.74770063697392, 46.74076487892657],
        [142.0920300640545, 45.96675527605879],
        [141.90692508358504, 46.80592886004655],
        [142.0184428244709, 47.780132961612935],
        [141.90444461483506, 48.85918854429957],
        [142.13580000220568, 49.61516307229746],
        [142.1799833518153, 50.95234243428192],
        [141.59407596249005, 51.93543488220254],
        [141.68254601457366, 53.30196645772878],
        [142.60693403541077, 53.762145087287905],
        [142.2097489768154, 54.22547597921687],
        [142.654786411713, 54.36588084575388],
        [142.91461551327657, 53.70457754171474],
        [143.26084760963207, 52.74076040303905],
        [143.23526777564766, 51.75666026468875],
        [143.64800744036287, 50.74760040954152],
      ],
    ],
    [
      [
        [22.731098667092652, 54.327536932993326],
        [20.892244500418656, 54.312524929412575],
        [19.660640089606403, 54.426083889373984],
        [19.888481479581344, 54.8661603867715],
        [21.2684489275035, 55.19048167583529],
        [22.315723504330606, 55.0152985703659],
        [22.757763706155288, 54.85657440858142],
        [22.651051873472568, 54.58274099386671],
        [22.731098667092652, 54.327536932993326],
      ],
    ],
    [
      [
        [-175.01425, 66.58435],
        [-174.33983, 66.33556],
        [-174.57182, 67.06219],
        [-171.85731, 66.91308],
        [-169.89958, 65.97724],
        [-170.89107, 65.54139],
        [-172.53025, 65.43791],
        [-172.555, 64.46079],
        [-172.95533, 64.25269],
        [-173.89184, 64.2826],
        [-174.65392, 64.63125],
        [-175.98353, 64.92288],
        [-176.20716, 65.35667],
        [-177.22266, 65.52024],
        [-178.35993, 65.39052],
        [-178.90332, 65.74044],
        [-178.68611, 66.11211],
        [-179.88377, 65.87456],
        [-179.43268, 65.40411],
        [-180, 64.97970870219837],
        [-180, 68.96363636363637],
        [-177.55, 68.2],
        [-174.92825, 67.20589],
        [-175.01425, 66.58435],
      ],
    ],
    [
      [
        [180.00000000000014, 70.83219920854668],
        [178.9034250000001, 70.78114],
        [178.7253, 71.0988],
        [180.00000000000014, 71.51571433642826],
        [180.00000000000014, 70.83219920854668],
      ],
    ],
    [
      [
        [-178.69378, 70.89302],
        [-180, 70.83219920854668],
        [-180, 71.51571433642826],
        [-179.87187, 71.55762],
        [-179.02433, 71.55553],
        [-177.577945, 71.26948],
        [-177.663575, 71.13277],
        [-178.69378, 70.89302],
      ],
    ],
    [
      [
        [143.60385, 73.21244],
        [142.08763, 73.20544],
        [140.038155, 73.31692],
        [139.86312, 73.36983],
        [140.81171, 73.76506],
        [142.06207, 73.85758],
        [143.48283, 73.47525],
        [143.60385, 73.21244],
      ],
    ],
    [
      [
        [150.73167, 75.08406],
        [149.575925, 74.68892],
        [147.97746, 74.778355],
        [146.11919, 75.17298],
        [146.358485, 75.49682],
        [148.22223, 75.345845],
        [150.73167, 75.08406],
      ],
    ],
    [
      [
        [145.086285, 75.56262],
        [144.3, 74.82],
        [140.61381, 74.84768],
        [138.95544, 74.61148],
        [136.97439, 75.26167],
        [137.51176, 75.94917],
        [138.831075, 76.13676],
        [141.47161, 76.09289],
        [145.086285, 75.56262],
      ],
    ],
    [
      [
        [57.5356925799924, 70.72046397570216],
        [56.94497928246395, 70.63274323188668],
        [53.6773751157842, 70.76265778266847],
        [53.41201663596539, 71.2066616889202],
        [51.60189456564572, 71.47475901965049],
        [51.45575361512422, 72.01488108996514],
        [52.47827518088357, 72.22944163684096],
        [52.444168735570855, 72.77473135038485],
        [54.42761355979766, 73.62754751249759],
        [53.50828982932515, 73.74981395130015],
        [55.90245893740766, 74.62748647734534],
        [55.631932814359715, 75.08141225859717],
        [57.86864383324885, 75.60939036732321],
        [61.170044386647504, 76.25188345000814],
        [64.49836836127022, 76.43905548776928],
        [66.2109770038551, 76.80978221303124],
        [68.15705976753483, 76.93969676381292],
        [68.85221113472514, 76.54481130645462],
        [68.18057254422766, 76.23364166940911],
        [64.63732628770302, 75.73775462513623],
        [61.58350752141476, 75.2608845079468],
        [58.47708214705338, 74.30905630156283],
        [56.98678551618801, 73.33304352486624],
        [55.419335971910954, 72.37126760526598],
        [55.622837762276305, 71.54059479439033],
        [57.5356925799924, 70.72046397570216],
      ],
    ],
    [
      [
        [106.97013000000013, 76.97419],
        [107.24000000000015, 76.48],
        [108.1538, 76.72335000000015],
        [111.07726000000017, 76.71],
        [113.33151, 76.22224],
        [114.13417, 75.84764],
        [113.88539, 75.32779000000014],
        [112.77918, 75.03186],
        [110.1512500000002, 74.47673],
        [109.4, 74.18],
        [110.64, 74.04],
        [112.11919, 73.78774000000013],
        [113.01954000000026, 73.97693000000015],
        [113.52958000000032, 73.33505000000011],
        [113.96881, 73.5948800000001],
        [115.56782, 73.75285],
        [118.77633000000023, 73.58772],
        [119.02, 73.12],
        [123.20066000000011, 72.97122],
        [123.25777000000019, 73.73503000000011],
        [125.3800000000002, 73.56],
        [126.97644, 73.56549],
        [128.59126, 73.03871],
        [129.05157, 72.39872],
        [128.46000000000012, 71.98],
        [129.71599000000023, 71.19304],
        [131.28858000000028, 70.78699000000012],
        [132.25350000000017, 71.83630000000011],
        [133.85766000000032, 71.38642000000016],
        [135.56193, 71.65525000000014],
        [137.49755, 71.34763],
        [138.23409000000018, 71.62803],
        [139.86983000000012, 71.48783000000014],
        [139.14791, 72.41619000000011],
        [140.46817, 72.84941000000015],
        [149.5, 72.2],
        [150.3511800000002, 71.60643],
        [152.96890000000022, 70.84222],
        [157.00688, 71.03141],
        [158.99779, 70.86672],
        [159.83031000000025, 70.45324],
        [159.70866, 69.72198],
        [160.94053000000034, 69.4372800000001],
        [162.27907000000013, 69.64204],
        [164.05248000000014, 69.66823],
        [165.94037000000023, 69.47199],
        [167.83567, 69.58269],
        [169.5776300000002, 68.6938],
        [170.81688000000028, 69.01363],
        [170.0082000000002, 69.65276],
        [170.4534500000003, 70.09703],
        [173.64391000000026, 69.81743],
        [175.72403000000023, 69.87725000000023],
        [178.6, 69.4],
        [180.00000000000014, 68.96363636363657],
        [180.00000000000014, 64.97970870219848],
        [179.99281, 64.97433],
        [178.70720000000026, 64.53493],
        [177.41128000000018, 64.60821],
        [178.31300000000024, 64.07593],
        [178.9082500000002, 63.25197000000014],
        [179.37034, 62.98262000000011],
        [179.48636, 62.56894],
        [179.22825000000014, 62.30410000000015],
        [177.3643, 62.5219],
        [174.56929000000022, 61.76915],
        [173.68013, 61.65261],
        [172.15, 60.95],
        [170.6985000000001, 60.33618],
        [170.3308500000003, 59.88177],
        [168.90046, 60.57355],
        [166.29498000000032, 59.788550000000214],
        [165.84000000000023, 60.16],
        [164.87674, 59.7316],
        [163.53929000000014, 59.86871],
        [163.21711000000025, 59.21101],
        [162.0173300000001, 58.24328],
        [162.05297, 57.83912],
        [163.19191, 57.615030000000104],
        [163.05794000000017, 56.159240000000125],
        [162.12958000000023, 56.12219],
        [161.70146, 55.285680000000156],
        [162.11749000000017, 54.85514],
        [160.36877000000035, 54.34433],
        [160.02173000000025, 53.20257],
        [158.5309400000002, 52.95868000000024],
        [158.23118, 51.94269],
        [156.7897900000003, 51.01105],
        [156.42000000000016, 51.7],
        [155.99182, 53.15895],
        [155.43366000000012, 55.38103000000012],
        [155.91442000000032, 56.767920000000146],
        [156.75815, 57.3647],
        [156.8103500000001, 57.83204],
        [158.3643300000002, 58.05575],
        [160.15064000000015, 59.314770000000124],
        [161.87204, 60.34300000000013],
        [163.66969, 61.1409000000001],
        [164.47355000000013, 62.55061],
        [163.2584200000002, 62.46627],
        [162.65791, 61.6425],
        [160.1214800000001, 60.54423],
        [159.30232, 61.7739600000001],
        [156.7206800000001, 61.43442],
        [154.21806000000035, 59.758180000000124],
        [155.04375, 59.14495],
        [152.81185, 58.88385],
        [151.26573000000027, 58.78089],
        [151.33815000000013, 59.50396],
        [149.78371, 59.65573000000015],
        [148.54481, 59.16448],
        [145.48722, 59.33637],
        [142.19782000000018, 59.03998],
        [138.95848000000032, 57.08805],
        [135.12619, 54.72959],
        [136.70171, 54.603550000000126],
        [137.19342, 53.97732],
        [138.1647, 53.755010000000254],
        [138.80463, 54.25455000000011],
        [139.90151, 54.18968000000018],
        [141.34531, 53.08957000000012],
        [141.37923, 52.23877],
        [140.5974200000002, 51.2396700000001],
        [140.51308, 50.04553000000013],
        [140.06193000000022, 48.44671000000017],
        [138.55472000000023, 46.99965],
        [138.21971, 46.30795],
        [136.86232, 45.14350000000019],
        [135.5153500000002, 43.989],
        [134.86939000000027, 43.39821],
        [133.53687000000028, 42.81147],
        [132.90627000000015, 42.7984900000001],
        [132.27807000000027, 43.28456000000011],
        [130.93587000000016, 42.55274],
        [130.78, 42.2200000000002],
        [130.64000000000019, 42.395],
        [130.63386640840983, 42.90301463477056],
        [131.144687941615, 42.92998973242695],
        [131.28855512911562, 44.111519680348266],
        [131.02519000000026, 44.96796],
        [131.8834542176596, 45.32116160743652],
        [133.09712000000022, 45.14409],
        [133.7696439963132, 46.116926988299156],
        [134.1123500000002, 47.21248000000014],
        [134.50081, 47.578450000000146],
        [135.0263114767868, 48.47822988544391],
        [133.37359581922803, 48.18344167743484],
        [132.50669000000013, 47.78896],
        [130.98726000000013, 47.79013],
        [130.58229332898267, 48.729687404976204],
        [129.3978178244205, 49.440600084015614],
        [127.65740000000037, 49.76027],
        [127.28745568248493, 50.73979726826545],
        [126.93915652883786, 51.35389415140591],
        [126.564399041857, 51.7842554795327],
        [125.94634891164648, 52.79279857035695],
        [125.06821129771046, 53.16104482686893],
        [123.57147, 53.4588],
        [122.24574791879306, 53.431725979213695],
        [121.00308475147037, 53.25140106873124],
        [120.1770886577169, 52.75388621684121],
        [120.725789015792, 52.51622630473091],
        [120.7382, 51.96411],
        [120.18208000000018, 51.64355],
        [119.27939, 50.58292],
        [119.28846072802585, 50.14288279886196],
        [117.8792444194265, 49.51098338479704],
        [116.67880089728621, 49.888531399121405],
        [115.48569542853144, 49.80517731383475],
        [114.9621098165504, 50.14024730081513],
        [114.36245649623535, 50.248302720737485],
        [112.89773969935439, 49.54356537535699],
        [111.58123091028668, 49.37796824807768],
        [110.66201053267886, 49.13012807880585],
        [109.40244917199672, 49.29296051695769],
        [108.47516727095129, 49.28254771585071],
        [107.86817589725112, 49.793705145865886],
        [106.88880415245532, 50.27429596618029],
        [105.8865914245869, 50.406019192092174],
        [104.62158, 50.275320000000164],
        [103.67654544476036, 50.089966132195144],
        [102.25589000000011, 50.51056000000011],
        [102.06521, 51.259910000000104],
        [100.88948042196265, 51.51685578063842],
        [99.98173221232358, 51.63400625264396],
        [98.8614905131005, 52.04736603454671],
        [97.82573978067452, 51.01099518493325],
        [98.23176150919173, 50.42240062112873],
        [97.25976000000023, 49.72605],
        [95.81402000000017, 49.97746000000012],
        [94.81594933469879, 50.01343333597089],
        [94.14756635943561, 50.48053660745717],
        [93.10421, 50.49529],
        [92.23471154171969, 50.80217072204175],
        [90.71366743364078, 50.331811835321105],
        [88.80556684769559, 49.47052073831247],
        [87.75126427607685, 49.29719798440556],
        [87.3599703307627, 49.21498078062916],
        [86.82935672398966, 49.82667470966814],
        [85.5412699726825, 49.69285858824816],
        [85.11555952346211, 50.11730296487764],
        [84.41637739455305, 50.311399644565824],
        [83.93511478061893, 50.88924551045358],
        [83.38300377801247, 51.069182847693895],
        [81.94598554883996, 50.81219594990634],
        [80.56844689323546, 51.38833649352844],
        [80.03555952344172, 50.864750881547224],
        [77.80091556184433, 53.40441498474755],
        [76.52517947785478, 54.17700348572714],
        [76.89110029491346, 54.49052440044193],
        [74.38482000000013, 53.54685000000012],
        [73.42567874542053, 53.489810289109755],
        [73.50851606638437, 54.0356167669766],
        [72.22415001820221, 54.37665538188679],
        [71.1801310566095, 54.13328522400826],
        [70.86526655465516, 55.169733588270105],
        [69.0681669452729, 55.3852501491435],
        [68.16910037625891, 54.97039175070438],
        [65.6668700000001, 54.601250000000164],
        [65.17853356309595, 54.35422781027208],
        [61.43660000000014, 54.00625],
        [60.97806644068325, 53.66499339457914],
        [61.699986199800634, 52.97999644633427],
        [60.73999311711455, 52.71998647725775],
        [60.92726850774025, 52.44754832621501],
        [59.967533807215574, 51.960420437215674],
        [61.58800337102414, 51.272658799843185],
        [61.33742435084102, 50.79907013610426],
        [59.932807244715576, 50.842194118851836],
        [59.64228234237058, 50.545442206415714],
        [58.36332000000013, 51.06364],
        [56.77798, 51.04355],
        [55.71694000000011, 50.62171000000015],
        [54.532878452376195, 51.02623973245937],
        [52.32872358583106, 51.718652248738096],
        [50.76664839051219, 51.692762356159875],
        [48.70238162618105, 50.60512848571284],
        [48.577841424357615, 49.874759629915644],
        [47.549480421749394, 50.454698391311126],
        [46.75159630716277, 49.35600576435374],
        [47.0436715024766, 49.152038886097586],
        [46.4664457537763, 48.39415233010493],
        [47.31524000000016, 47.71585],
        [48.05725, 47.74377],
        [48.694733514201886, 47.0756281601779],
        [48.593250000000154, 46.561040000000105],
        [49.101160000000135, 46.399330000000106],
        [48.64541000000011, 45.80629],
        [47.67591, 45.64149000000012],
        [46.68201, 44.6092000000001],
        [47.59094, 43.66016000000013],
        [47.49252, 42.98658],
        [48.58437000000018, 41.80888],
        [47.98728315612604, 41.4058192001944],
        [47.81566572448466, 41.15141612402135],
        [47.373315464066394, 41.21973236751114],
        [46.686070591016716, 41.827137152669906],
        [46.40495079934894, 41.86067515722743],
        [45.7764, 42.09244000000024],
        [45.470279168485916, 42.50278066667005],
        [44.53762291848207, 42.711992702803684],
        [43.93121000000011, 42.55496000000011],
        [43.755990000000196, 42.74083],
        [42.39440000000016, 43.2203],
        [40.92219000000014, 43.38215000000014],
        [40.07696495947985, 43.553104153002494],
        [39.955008579271095, 43.434997666999294],
        [38.68, 44.28],
        [37.53912000000011, 44.65721],
        [36.67546000000013, 45.24469],
        [37.40317, 45.4045100000001],
        [38.23295, 46.24087],
        [37.67372, 46.63657],
        [39.14767, 47.044750000000136],
        [39.12120000000013, 47.26336],
        [38.22353803889948, 47.10218984637598],
        [38.25511233902981, 47.54640045835697],
        [38.77057, 47.82562000000024],
        [39.738277622238996, 47.89893707945208],
        [39.89562000000015, 48.23241],
        [39.67465, 48.783820000000134],
        [40.08078901546949, 49.30742991799937],
        [40.069040000000115, 49.60105],
        [38.59498823421356, 49.92646190042373],
        [38.010631137857075, 49.91566152607473],
        [37.39345950699524, 50.38395335550368],
        [36.626167840325394, 50.225590928745135],
        [35.35611616388812, 50.57719737405915],
        [35.37791, 50.77394],
        [35.02218305841794, 51.2075723333715],
        [34.22481570815441, 51.255993150428935],
        [34.14197838719062, 51.566413479206204],
        [34.391730584457235, 51.768881740925906],
        [33.75269982273588, 52.33507457133166],
        [32.71576053236717, 52.238465481162166],
        [32.412058139787774, 52.28869497334978],
        [32.15944000000022, 52.061250000000115],
        [31.78597, 52.10168],
        [31.54001834486226, 52.74205231384644],
        [31.305200636527985, 53.07399587667331],
        [31.49764, 53.16743000000014],
        [32.304519484188376, 53.13272614197285],
        [32.693643019346126, 53.35142080343215],
        [32.405598585751164, 53.618045355842014],
        [31.731272820774592, 53.79402944601202],
        [31.791424187962406, 53.974638576872195],
        [31.384472283663825, 54.15705638286238],
        [30.75753380709878, 54.8117709417844],
        [30.97183597181325, 55.081547756564134],
        [30.87390913262007, 55.55097646750352],
        [29.89629438652244, 55.7894632025305],
        [29.37157189303079, 55.67009064393628],
        [29.229513380660393, 55.91834422466641],
        [28.17670942557794, 56.16912995057879],
        [27.855282016722526, 56.75932648378438],
        [27.770015903440992, 57.2442581244112],
        [27.288184848751655, 57.47452830670392],
        [27.71668582531578, 57.79189911562446],
        [27.420150000000206, 58.72457000000014],
        [28.131699253051863, 59.300825100331],
        [27.98112, 59.47537],
        [29.1177, 60.02805000000012],
        [28.07, 60.50352000000015],
        [30.211107212044652, 61.780027777749694],
        [31.139991082491036, 62.35769277612445],
        [31.516092156711267, 62.867687486412905],
        [30.035872430142803, 63.552813625738565],
        [30.44468468600374, 64.20445343693908],
        [29.544429559047018, 64.94867157659056],
        [30.21765, 65.80598],
        [29.054588657352383, 66.94428620062203],
        [29.977426385220696, 67.69829702419275],
        [28.445943637818772, 68.364612942164],
        [28.591929559043365, 69.0647769232867],
        [29.39955, 69.15692000000018],
        [31.10108000000011, 69.55811],
        [32.13272000000026, 69.90595000000025],
        [33.77547, 69.30142000000012],
        [36.51396, 69.06342],
        [40.292340000000166, 67.9324],
        [41.05987000000013, 67.45713000000012],
        [41.12595000000019, 66.79158000000012],
        [40.01583, 66.26618000000013],
        [38.38295, 65.9995300000001],
        [33.918710000000175, 66.75961],
        [33.18444, 66.63253],
        [34.81477, 65.90015000000014],
        [34.87857425307877, 65.4362128770482],
        [34.94391000000016, 64.41437000000016],
        [36.23129, 64.10945],
        [37.01273000000012, 63.84983000000011],
        [37.14197000000016, 64.33471],
        [36.539579035089815, 64.76446],
        [37.17604000000014, 65.14322000000013],
        [39.59345, 64.52079000000018],
        [40.43560000000011, 64.76446],
        [39.76260000000016, 65.49682],
        [42.0930900000001, 66.47623],
        [43.01604000000012, 66.4185800000001],
        [43.94975000000014, 66.06908],
        [44.53226, 66.75634000000014],
        [43.69839, 67.35245],
        [44.18795000000014, 67.95051],
        [43.45282, 68.57079],
        [46.25000000000014, 68.25],
        [46.82134000000016, 67.68997],
        [45.55517, 67.56652],
        [45.5620200000001, 67.0100500000002],
        [46.34915000000015, 66.6676700000001],
        [47.894160000000255, 66.88455000000016],
        [48.13876, 67.52238],
        [50.22766000000016, 67.99867000000015],
        [53.71743000000018, 68.85738000000012],
        [54.47171, 68.80815],
        [53.48582000000013, 68.20131],
        [54.72628, 68.09702],
        [55.44268000000014, 68.43866],
        [57.317020000000156, 68.46628],
        [58.80200000000022, 68.88082],
        [59.94142000000019, 68.2784400000001],
        [61.07784000000018, 68.94069],
        [60.03, 69.52],
        [60.55, 69.85],
        [63.50400000000016, 69.54739],
        [64.888115, 69.23483500000015],
        [68.51216000000014, 68.09233000000017],
        [69.18068, 68.61563000000012],
        [68.16444, 69.14436],
        [68.13522, 69.35649],
        [66.93008000000012, 69.45461000000012],
        [67.25976, 69.92873],
        [66.72492000000014, 70.70889000000014],
        [66.69466, 71.02897000000024],
        [68.54006000000012, 71.93450000000024],
        [69.19636000000011, 72.84336000000016],
        [69.94, 73.04000000000013],
        [72.58754, 72.7762900000001],
        [72.79603, 72.22006],
        [71.8481100000001, 71.40898],
        [72.47011, 71.09019],
        [72.79188, 70.39114],
        [72.56470000000022, 69.02085],
        [73.66787, 68.4079],
        [73.2387, 67.7404],
        [71.28000000000011, 66.32000000000016],
        [72.42301000000018, 66.17267000000018],
        [72.82077, 66.53267],
        [73.92099000000016, 66.78946000000013],
        [74.1865100000002, 67.28429],
        [75.052, 67.76047000000017],
        [74.46926000000016, 68.32899],
        [74.93584000000013, 68.98918],
        [73.84236, 69.07146],
        [73.60187000000022, 69.62763],
        [74.3998, 70.63175],
        [73.1011, 71.44717000000026],
        [74.89082000000022, 72.12119],
        [74.65926, 72.83227],
        [75.15801000000019, 72.85497000000012],
        [75.68351, 72.30056000000013],
        [75.28898000000012, 71.33556],
        [76.35911, 71.15287000000015],
        [75.90313000000017, 71.87401],
        [77.57665000000011, 72.26717],
        [79.65202000000014, 72.32011],
        [81.5, 71.75],
        [80.61071000000013, 72.58285000000012],
        [80.51109, 73.6482],
        [82.25, 73.85000000000011],
        [84.65526, 73.80591000000018],
        [86.82230000000024, 73.93688],
        [86.00956, 74.45967000000016],
        [87.16682000000017, 75.11643],
        [88.31571000000011, 75.14393],
        [90.26, 75.64],
        [92.90058, 75.77333],
        [93.23421000000016, 76.0472],
        [95.86000000000016, 76.1400000000001],
        [96.67821, 75.91548],
        [98.92254000000023, 76.44689],
        [100.75967000000023, 76.43028],
        [101.03532, 76.86189],
        [101.99084000000013, 77.2875400000002],
        [104.3516000000001, 77.69792],
        [106.06664000000015, 77.37389],
        [104.70500000000024, 77.1274],
        [106.97013000000013, 76.97419],
      ],
    ],
    [
      [
        [105.07547, 78.30689],
        [99.43814, 77.921],
        [101.2649, 79.23399],
        [102.08635, 79.34641],
        [102.837815, 79.28129],
        [105.37243, 78.71334],
        [105.07547, 78.30689],
      ],
    ],
    [
      [
        [51.13618655783128, 80.54728017854094],
        [49.79368452332071, 80.41542776154822],
        [48.89441124857754, 80.3395667589437],
        [48.754936557821765, 80.17546824820084],
        [47.586119012244154, 80.01018117951534],
        [46.502825962109654, 80.24724681265437],
        [47.07245527526291, 80.55942414012947],
        [44.846958042181114, 80.58980988231718],
        [46.79913862487123, 80.77191762971364],
        [48.318477410684665, 80.78400991486996],
        [48.522806023966695, 80.51456899690015],
        [49.09718956889091, 80.75398590770843],
        [50.03976769389462, 80.91888540315182],
        [51.52293297710369, 80.69972565380192],
        [51.13618655783128, 80.54728017854094],
      ],
    ],
    [
      [
        [99.93976, 78.88094],
        [97.75794, 78.7562],
        [94.97259, 79.044745],
        [93.31288, 79.4265],
        [92.5454, 80.14379],
        [91.18107, 80.34146],
        [93.77766, 81.0246],
        [95.940895, 81.2504],
        [97.88385, 80.746975],
        [100.186655, 79.780135],
        [99.93976, 78.88094],
      ],
    ],
  ],
  SE: [
    [
      [
        [22.18317345550193, 65.72374054632017],
        [21.21351687997722, 65.02600535751527],
        [21.369631381930958, 64.41358795842429],
        [19.77887576669022, 63.60955434839504],
        [17.84777916837521, 62.74940013289681],
        [17.119554884518124, 61.34116567651097],
        [17.83134606290639, 60.63658336042741],
        [18.78772179533209, 60.081914374422595],
        [17.86922488777634, 58.9537661810587],
        [16.829185011470088, 58.71982697207339],
        [16.447709588291474, 57.041118069071885],
        [15.879785597403783, 56.10430186626866],
        [14.666681349352075, 56.200885118222175],
        [14.100721062891465, 55.40778107362265],
        [12.942910597392057, 55.36173737245058],
        [12.625100538797028, 56.30708018658197],
        [11.787942335668674, 57.44181712506307],
        [11.027368605196868, 58.85614940045936],
        [11.468271925511146, 59.43239329694604],
        [12.3003658382749, 60.11793284773003],
        [12.631146681375185, 61.293571682370136],
        [11.992064243221563, 61.80036245385655],
        [11.930569288794231, 63.12831757267698],
        [12.579935336973934, 64.06621898055833],
        [13.571916131248713, 64.04911408146971],
        [13.919905226302204, 64.44542064071608],
        [13.55568973150909, 64.78702769638151],
        [15.108411492583002, 66.19386688909547],
        [16.108712192456778, 67.30245555283689],
        [16.768878614985482, 68.0139366726314],
        [17.729181756265348, 68.01055186631628],
        [17.993868442464333, 68.56739126247736],
        [19.878559604581255, 68.40719432237258],
        [20.025268995857886, 69.0651386583127],
        [20.645592889089528, 69.10624726020087],
        [21.978534783626117, 68.6168456081807],
        [23.53947309743444, 67.93600861273525],
        [23.565879754335583, 66.39605093043743],
        [23.903378533633802, 66.00692739527962],
        [22.18317345550193, 65.72374054632017],
      ],
    ],
  ],
  GB: [
    [
      [
        [-5.661948614921897, 54.55460317648385],
        [-6.197884894220977, 53.86756500916334],
        [-6.953730231137996, 54.073702297575636],
        [-7.572167934591079, 54.05995636658599],
        [-7.366030646178785, 54.595840969452695],
        [-7.572167934591079, 55.1316222194549],
        [-6.733847011736145, 55.1728600124238],
        [-5.661948614921897, 54.55460317648385],
      ],
    ],
    [
      [
        [-3.005004848635281, 58.63500010846633],
        [-4.073828497728016, 57.55302480735526],
        [-3.055001796877661, 57.69001902936094],
        [-1.959280564776918, 57.68479970969952],
        [-2.219988165689301, 56.87001740175353],
        [-3.119003058271119, 55.973793036515474],
        [-2.085009324543023, 55.90999848085127],
        [-2.005675679673857, 55.80490285035023],
        [-1.11499101399221, 54.624986477265395],
        [-0.4304849918542, 54.46437612570216],
        [0.184981316742039, 53.32501414653103],
        [0.469976840831777, 52.92999949809197],
        [1.681530795914739, 52.739520168664],
        [1.559987827164377, 52.09999848083601],
        [1.050561557630914, 51.806760565795685],
        [1.449865349950301, 51.28942780212196],
        [0.550333693045502, 50.765738837275876],
        [-0.78751746255864, 50.77498891865622],
        [-2.489997524414377, 50.50001862243124],
        [-2.956273972984036, 50.696879991247016],
        [-3.617448085942328, 50.22835561787272],
        [-4.542507900399244, 50.341837063185665],
        [-5.245023159191135, 49.95999990498109],
        [-5.776566941745301, 50.15967763935683],
        [-4.309989793301838, 51.21000112568916],
        [-3.414850633142123, 51.42600861266925],
        [-3.422719467108323, 51.42684816740609],
        [-4.984367234710874, 51.593466091510976],
        [-5.267295701508885, 51.991400458374585],
        [-4.222346564134853, 52.301355699261364],
        [-4.770013393564113, 52.840004991255626],
        [-4.579999152026915, 53.49500377055517],
        [-3.093830673788659, 53.404547400669685],
        [-3.092079637047107, 53.40444082296355],
        [-2.945008510744344, 53.984999701546684],
        [-3.614700825433033, 54.600936773292574],
        [-3.630005458989331, 54.615012925833014],
        [-4.844169073903004, 54.790971177786844],
        [-5.082526617849226, 55.06160065369937],
        [-4.719112107756644, 55.50847260194348],
        [-5.047980922862109, 55.78398550070753],
        [-5.58639767091114, 55.31114614523682],
        [-5.644998745130181, 56.275014960344805],
        [-6.149980841486354, 56.78500967063354],
        [-5.786824713555291, 57.81884837506465],
        [-5.009998745127575, 58.63001333275005],
        [-4.211494513353557, 58.55084503847917],
        [-3.005004848635281, 58.63500010846633],
      ],
    ],
  ],
  DE: [
    [
      [
        [9.921906365609232, 54.98310415304803],
        [9.9395797054529, 54.596641954153256],
        [10.950112338920519, 54.363607082733154],
        [10.93946699386845, 54.00869334575259],
        [11.956252475643282, 54.19648550070116],
        [12.518440382546714, 54.470370591847995],
        [13.647467075259499, 54.0755109727059],
        [14.119686313542559, 53.75702912049104],
        [14.353315463934166, 53.248171291713106],
        [14.074521111719434, 52.98126251892535],
        [14.437599725002201, 52.624850165408304],
        [14.685026482815715, 52.089947414755216],
        [14.607098422919648, 51.74518809671997],
        [15.016995883858783, 51.10667409932171],
        [14.570718214586122, 51.00233938252438],
        [14.307013380600665, 51.11726776794137],
        [14.056227654688314, 50.92691762959436],
        [13.338131951560399, 50.73323436136428],
        [12.96683678554325, 50.48407644306917],
        [12.240111118222671, 50.26633779560723],
        [12.415190870827473, 49.96912079528062],
        [12.521024204161336, 49.54741526956275],
        [13.031328973043514, 49.30706818297324],
        [13.595945672264577, 48.877171942737164],
        [13.243357374737116, 48.41611481382904],
        [12.884102817443875, 48.28914581968786],
        [13.025851271220517, 47.63758352313596],
        [12.932626987366064, 47.467645575544],
        [12.620759718484521, 47.672387600284424],
        [12.141357456112871, 47.70308340106578],
        [11.426414015354851, 47.52376618101306],
        [10.544504021861599, 47.5663992376538],
        [10.402083774465325, 47.30248769793917],
        [9.89606814946319, 47.580196845075704],
        [9.594226108446378, 47.5250580918202],
        [8.522611932009795, 47.83082754169135],
        [8.317301466514095, 47.61357982033627],
        [7.466759067422288, 47.62058197691192],
        [7.593676385131062, 48.33301911070373],
        [8.099278598674857, 49.01778351500343],
        [6.65822960778371, 49.20195831969164],
        [6.186320428094177, 49.463802802114515],
        [6.242751092156993, 49.90222565367873],
        [6.043073357781111, 50.128051662794235],
        [6.15665815595878, 50.80372101501058],
        [5.988658074577813, 51.851615709025054],
        [6.589396599970826, 51.852029120483394],
        [6.842869500362383, 52.22844025329755],
        [7.092053256873896, 53.144043280644894],
        [6.905139601274129, 53.48216217713065],
        [7.100424838905269, 53.69393219666267],
        [7.936239454793963, 53.74829580343379],
        [8.121706170289485, 53.52779246684429],
        [8.800734490604668, 54.020785630908904],
        [8.57211795414537, 54.39564647075406],
        [8.526229282270208, 54.96274363872516],
        [9.282048780971138, 54.83086538351631],
        [9.921906365609232, 54.98310415304803],
      ],
    ],
  ],
  TR: [
    [
      [
        [36.91312706884216, 41.335358384764305],
        [38.34766482926452, 40.94858612727572],
        [39.51260664242025, 41.102762763018575],
        [40.37343265153825, 41.013672593747344],
        [41.554084100110714, 41.53565623632761],
        [42.619548781104555, 41.58317271581993],
        [43.58274580259271, 41.09214325618257],
        [43.7526579119685, 40.74020091405882],
        [43.65643639504097, 40.25356395116617],
        [44.400008579288766, 40.00500031184231],
        [44.793989699082005, 39.713002631177034],
        [44.10922529478236, 39.428136298168056],
        [44.4214026222576, 38.28128123631453],
        [44.22575564960053, 37.97158437758935],
        [44.77269900897775, 37.17044464776845],
        [44.29345177590287, 37.00151439060636],
        [43.94225874204736, 37.256227525372935],
        [42.77912560402186, 37.38526357680581],
        [42.34959109881177, 37.22987254490411],
        [41.21208947120303, 37.07435232192174],
        [40.673259311695716, 37.09127635349736],
        [39.52258019385252, 36.71605377862602],
        [38.69989139176593, 36.71292735447233],
        [38.16772749202417, 36.90121043552779],
        [37.06676110204583, 36.62303620050062],
        [36.739494256341374, 36.817520453431115],
        [36.68538903173183, 36.259699205056506],
        [36.41755008316309, 36.0406169703551],
        [36.14976281102659, 35.82153473565367],
        [35.782084995269855, 36.27499542901492],
        [36.160821567537056, 36.650605577128374],
        [35.55093631362834, 36.56544281671134],
        [34.714553256984374, 36.795532131490916],
        [34.02689497247647, 36.21996002862397],
        [32.5091581560641, 36.1075637883892],
        [31.699595167779563, 36.64427521417261],
        [30.62162479017107, 36.677864895162315],
        [30.39109622571712, 36.26298065850699],
        [29.699975620245567, 36.14435740818101],
        [28.732902866335394, 36.67683136651644],
        [27.64118655773737, 36.658822129862756],
        [27.048767937943296, 37.65336090753601],
        [26.31821821463305, 38.208133246405396],
        [26.804700148228733, 38.98576019953356],
        [26.17078535330438, 39.463612168936464],
        [27.280019972449395, 40.42001373957831],
        [28.81997765474722, 40.46001129817222],
        [29.240003696415584, 41.21999074967269],
        [31.145933872204438, 41.087621568357065],
        [32.34797936374579, 41.73626414648464],
        [33.51328291192752, 42.01896006933731],
        [35.16770389175187, 42.040224921225445],
        [36.91312706884216, 41.335358384764305],
      ],
    ],
    [
      [
        [27.19237674328241, 40.690565700842455],
        [26.35800906749779, 40.15199392349649],
        [26.04335127127254, 40.61775360774317],
        [26.056942172965336, 40.82412344010075],
        [26.294602085075695, 40.93626129817417],
        [26.604195590936285, 41.56211456966102],
        [26.11704186372083, 41.82690460872456],
        [27.13573937349051, 42.141484890301314],
        [27.996720411905414, 42.007358710287775],
        [28.115524529744448, 41.622886054036286],
        [28.98844282401879, 41.29993419042819],
        [28.806438429486747, 41.05496206314854],
        [27.61901736828412, 40.99982330989312],
        [27.19237674328241, 40.690565700842455],
      ],
    ],
  ],
  CZ: [
    [
      [
        [16.960288120194576, 48.5969823268506],
        [16.499282667718774, 48.78580801044511],
        [16.02964725105022, 48.73389903420793],
        [15.253415561593982, 49.03907420510758],
        [14.901447381254057, 48.964401760445824],
        [14.338897739324722, 48.55530528420721],
        [13.595945672264437, 48.87717194273715],
        [13.031328973043431, 49.30706818297324],
        [12.521024204161193, 49.547415269562734],
        [12.415190870827445, 49.96912079528057],
        [12.240111118222558, 50.266337795607285],
        [12.966836785543194, 50.484076443069085],
        [13.338131951560285, 50.73323436136435],
        [14.056227654688172, 50.9269176295943],
        [14.307013380600637, 51.117267767941414],
        [14.570718214586066, 51.002339382524276],
        [15.01699588385867, 51.10667409932158],
        [15.490972120839729, 50.78472992614321],
        [16.23862674323857, 50.69773265237984],
        [16.176253289462267, 50.42260732685791],
        [16.719475945714436, 50.21574656839354],
        [16.86876915860566, 50.47397370055603],
        [17.55456709155112, 50.36214590107642],
        [17.64944502123899, 50.049038397819956],
        [18.392913852622172, 49.98862864847075],
        [18.853144158613617, 49.49622976337764],
        [18.554971144289482, 49.495015367218784],
        [18.399993523846177, 49.31500051533004],
        [18.170498488037964, 49.271514797556435],
        [18.104972771891852, 49.04398346617531],
        [17.913511590250465, 48.996492824899086],
        [17.88648481616181, 48.90347524677371],
        [17.545006951577108, 48.80001902932537],
        [17.101984897538898, 48.816968899117114],
        [16.960288120194576, 48.5969823268506],
      ],
    ],
  ],
  BR: [
    [
      [
        [-57.62513342958296, -30.21629485445426],
        [-56.29089962423908, -28.852760512000895],
        [-55.16228634298457, -27.881915378533463],
        [-54.490725267135524, -27.47475676850579],
        [-53.64873531758789, -26.92347258881609],
        [-53.628348965048744, -26.124865004177472],
        [-54.13004960795439, -25.547639255477254],
        [-54.625290696823576, -25.739255466415514],
        [-54.42894609233059, -25.162184747012166],
        [-54.29347632507745, -24.570799655863965],
        [-54.29295956075452, -24.02101409271073],
        [-54.65283423523513, -23.83957813893396],
        [-55.02790178080955, -24.00127369557523],
        [-55.40074723979542, -23.956935316668805],
        [-55.517639329639636, -23.571997572526637],
        [-55.610682745981144, -22.655619398694846],
        [-55.79795813660691, -22.356929620047822],
        [-56.47331743022939, -22.086300144135283],
        [-56.8815095689029, -22.28215382252148],
        [-57.937155727761294, -22.090175876557172],
        [-57.8706739976178, -20.73268767668195],
        [-58.166392381408045, -20.176700941653678],
        [-57.85380164247451, -19.96999521248619],
        [-57.949997321185826, -19.40000416430682],
        [-57.67600887717431, -18.96183969490403],
        [-57.49837114117099, -18.174187513911292],
        [-57.734558274961, -17.55246835700777],
        [-58.28080400250225, -17.271710300366017],
        [-58.38805843772404, -16.877109063385276],
        [-58.24121985536668, -16.299573256091293],
        [-60.158389655179036, -16.258283786690086],
        [-60.54296566429515, -15.093910414289596],
        [-60.251148851142936, -15.07721892665932],
        [-60.26432634137737, -14.645979099183641],
        [-60.45919816755003, -14.354007256734555],
        [-60.503304002511136, -13.775954685117659],
        [-61.08412126325565, -13.479383640194598],
        [-61.71320431176078, -13.489202162330052],
        [-62.127080857986385, -13.198780612849724],
        [-62.803060268796386, -13.000653171442686],
        [-63.19649878605057, -12.627032565972435],
        [-64.3163529120316, -12.461978041232193],
        [-65.40228146021303, -11.566270440317155],
        [-65.32189876978302, -10.895872084194679],
        [-65.44483700220539, -10.511451104375432],
        [-65.33843522811642, -9.761987806846392],
        [-66.6469083319628, -9.931331475466862],
        [-67.17380123561074, -10.306812432499612],
        [-68.04819230820539, -10.712059014532485],
        [-68.27125362819326, -11.01452117273682],
        [-68.78615759954948, -11.03638030359628],
        [-69.52967810736496, -10.951734307502194],
        [-70.0937522040469, -11.123971856331012],
        [-70.54868567572841, -11.009146823778465],
        [-70.48189388699117, -9.490118096558845],
        [-71.30241227892154, -10.079436130415374],
        [-72.18489071316985, -10.053597914269432],
        [-72.56303300646564, -9.520193780152717],
        [-73.22671342639016, -9.462212823121234],
        [-73.01538265653255, -9.032833347208062],
        [-73.57105933296707, -8.424446709835834],
        [-73.98723548042966, -7.523829847853065],
        [-73.7234014553635, -7.340998630404414],
        [-73.72448666044164, -6.91859547285064],
        [-73.1200274319236, -6.629930922068239],
        [-73.21971126981461, -6.089188734566078],
        [-72.9645072089412, -5.741251315944893],
        [-72.89192765978726, -5.274561455916981],
        [-71.74840572781655, -4.593982842633011],
        [-70.92884334988358, -4.401591485210368],
        [-70.7947688463023, -4.251264743673303],
        [-69.89363521999663, -4.298186944194327],
        [-69.44410193548961, -1.556287123219818],
        [-69.42048580593223, -1.122618503426409],
        [-69.5770653957766, -0.549991957200163],
        [-70.02065589057005, -0.185156345219539],
        [-70.01556576198931, 0.541414292804205],
        [-69.45239600287246, 0.706158758950693],
        [-69.25243404811906, 0.602650865070075],
        [-69.21863766140018, 0.985676581217433],
        [-69.80459672715773, 1.089081122233466],
        [-69.81697323269162, 1.714805202639624],
        [-67.86856502955884, 1.692455145673392],
        [-67.5378100246747, 2.03716278727633],
        [-67.2599975246736, 1.719998684084956],
        [-67.0650481838525, 1.130112209473225],
        [-66.87632585312258, 1.253360500489336],
        [-66.32576514348496, 0.724452215982012],
        [-65.54826738143757, 0.78925446207603],
        [-65.35471330428837, 1.0952822941085],
        [-64.61101192895987, 1.328730576987042],
        [-64.19930579289051, 1.49285492594602],
        [-64.08308549666609, 1.91636912679408],
        [-63.368788011311665, 2.200899562993129],
        [-63.42286739770512, 2.411067613124175],
        [-64.2699991522658, 2.497005520025567],
        [-64.40882788761792, 3.126786200366624],
        [-64.3684944322141, 3.797210394705246],
        [-64.81606401229402, 4.056445217297423],
        [-64.62865943058755, 4.14848094320925],
        [-63.88834286157416, 4.020530096854571],
        [-63.093197597899106, 3.770571193858785],
        [-62.804533047116706, 4.006965033377952],
        [-62.08542965355913, 4.162123521334308],
        [-60.96689327660154, 4.536467596856639],
        [-60.601179165271944, 4.91809804933213],
        [-60.73357418480372, 5.200277207861901],
        [-60.21368343773133, 5.244486395687602],
        [-59.980958624904886, 5.014061184098139],
        [-60.11100236676738, 4.574966538914083],
        [-59.767405768458715, 4.423502915866607],
        [-59.53803992373123, 3.958802598481938],
        [-59.815413174057866, 3.606498521332085],
        [-59.97452490908456, 2.755232652188056],
        [-59.71854570172675, 2.24963043864436],
        [-59.64604366722126, 1.786893825686789],
        [-59.03086157900265, 1.317697658692722],
        [-58.540012986878295, 1.268088283692521],
        [-58.429477098205965, 1.463941962078721],
        [-58.11344987652502, 1.507195135907025],
        [-57.66097103537737, 1.682584947105639],
        [-57.335822923396904, 1.948537705895759],
        [-56.78270423036083, 1.863710842288654],
        [-56.539385748914555, 1.899522609866921],
        [-55.995698004771754, 1.817667141116601],
        [-55.905600145070885, 2.02199575439866],
        [-56.0733418442903, 2.220794989425499],
        [-55.973322109589375, 2.510363877773017],
        [-55.569755011606, 2.421506252447131],
        [-55.09758744975514, 2.523748073736613],
        [-54.524754197799716, 2.311848863123785],
        [-54.08806250671725, 2.105556545414629],
        [-53.77852067728892, 2.376702785650082],
        [-53.554839240113544, 2.334896551925951],
        [-53.41846513529531, 2.053389187015981],
        [-52.939657151894956, 2.124857692875636],
        [-52.55642473001842, 2.504705308437053],
        [-52.249337531123956, 3.241094468596245],
        [-51.65779741067889, 4.156232408053029],
        [-51.31714636901086, 4.203490505383954],
        [-51.069771287629656, 3.650397650564031],
        [-50.508875291533656, 1.901563828942457],
        [-49.97407589374506, 1.736483465986069],
        [-49.94710079608871, 1.046189683431223],
        [-50.699251268096916, 0.222984117021682],
        [-50.38821082213214, -0.078444512536819],
        [-48.62056677915632, -0.235489190271821],
        [-48.58449662941659, -1.237805271005001],
        [-47.824956427590635, -0.5816179337628],
        [-46.566583624851226, -0.941027520352776],
        [-44.905703090990414, -1.551739597178134],
        [-44.417619187993665, -2.137750339367976],
        [-44.58158850765578, -2.691308282078524],
        [-43.418791266440195, -2.383110039889793],
        [-41.47265682632825, -2.912018324397116],
        [-39.97866533055404, -2.873054294449041],
        [-38.50038347019657, -3.700652357603396],
        [-37.2232521225352, -4.820945733258917],
        [-36.45293738457639, -5.109403578312154],
        [-35.59779578301047, -5.149504489770649],
        [-35.23538896334756, -5.464937432480247],
        [-34.89602983248683, -6.738193047719711],
        [-34.729993455533034, -7.343220716992967],
        [-35.12821204277422, -8.996401462442286],
        [-35.636966518687714, -9.649281508017815],
        [-37.046518724097, -11.040721123908803],
        [-37.68361161960736, -12.171194756725823],
        [-38.42387651218844, -13.038118584854288],
        [-38.67388709161652, -13.057652276260619],
        [-38.953275722802545, -13.793369642800023],
        [-38.88229814304965, -15.667053724838768],
        [-39.16109249526431, -17.208406670808472],
        [-39.2673392400564, -17.867746270420483],
        [-39.58352149103423, -18.262295830968938],
        [-39.76082333022764, -19.59911345792741],
        [-40.77474077001034, -20.904511814052423],
        [-40.94475623225061, -21.93731698983781],
        [-41.754164191238225, -22.370675551037458],
        [-41.98828426773656, -22.970070489190896],
        [-43.07470374202475, -22.96769337330547],
        [-44.64781185563781, -23.351959323827842],
        [-45.35213578955992, -23.796841729428582],
        [-46.47209326840554, -24.088968601174543],
        [-47.64897233742066, -24.885199069927722],
        [-48.4954581365777, -25.877024834905654],
        [-48.64100480812774, -26.623697605090932],
        [-48.474735887228654, -27.17591196056189],
        [-48.661520351747626, -28.18613453543572],
        [-48.8884574041574, -28.674115085567884],
        [-49.587329474472675, -29.224469089476337],
        [-50.696874152211485, -30.98446502047296],
        [-51.576226162306156, -31.77769825615321],
        [-52.256081305538046, -32.24536996839467],
        [-52.712099982297694, -33.19657805759118],
        [-53.373661668498244, -33.768377780900764],
        [-53.6505439927181, -33.20200408298183],
        [-53.209588995971544, -32.727666110974724],
        [-53.78795162618219, -32.047242526987624],
        [-54.57245154480512, -31.494511407193748],
        [-55.601510179249345, -30.853878676071393],
        [-55.97324459494094, -30.883075860316303],
        [-56.976025763564735, -30.109686374636127],
        [-57.62513342958296, -30.21629485445426],
      ],
    ],
  ],
};

export default geoData;
